import { selectXsrfToken } from 'modules/auth/selectors';
import type { Dispatch, GetState } from 'model/State';
import watchProgress from 'model/watchProgress';
import { fetchCartByOrderNumber } from '../cart';
import * as auth from 'modules/auth';

export default async (dispatch: Dispatch, getState: GetState) => {
  const xsrfToken = await watchProgress(selectXsrfToken);
  if (!xsrfToken) {
    auth.actions.goToLogin();
    return;
  }

  const { orderId } = getState().location.payload;
  const verificationHash = getState().location.query?.hash;

  dispatch(fetchCartByOrderNumber(orderId, verificationHash));
};
